export const ATTENDANCE_PLAN_IDS = ["attendance_monthly", "attendance_yearly", "free"];
export const TASKS_PLAN_IDS = ["tasks_monthly", "tasks_yearly"];
export const FULL_PLAN_IDS = ["full_monthly", "full_yearly"];

const ATTENDANCE_MENU_KEYS = new Set([
  "dashboard",
  "workers",
  "attendance",
  "notifications",
  "suppliers",
  "vacancies",
  "applicants",
  "settings",
  "logout",
]);

const TASKS_MENU_KEYS = new Set([...ATTENDANCE_MENU_KEYS, "tasks"]);

const ROUTE_MENU_MAP = [
  ["/dashboard", "dashboard"],
  ["/all-employees", "workers"],
  ["/department", "workers"],
  ["/todays-logs", "attendance"],
  ["/unvalidated-punches", "attendance"],
  ["/attendance-history", "attendance"],
  ["/attendance-settings", "attendance"],
  ["/all-tasks", "tasks"],
  ["/task-attendance-history", "tasks"],
  ["/task-calender", "tasks"],
  ["/messages", "messages"],
  ["/notifications", "notifications"],
  ["/request-management", "requests"],
  ["/worker-documents", "documents"],
  ["/companies-policies", "documents"],
  ["/Reimbursement-request", "expenses"],
  ["/payroll", "expenses"],
  ["/salary-records", "expenses"],
  ["/reports", "reports"],
  ["/reports-services", "reports"],
  ["/absence", "absences"],
  ["/suppliers", "suppliers"],
  ["/vacancies", "vacancies"],
  ["/applicants", "applicants"],
  ["/settings", "settings"],
];

export const getAllowedMenuKeys = (planId) => {
  if (!planId || ATTENDANCE_PLAN_IDS.includes(planId)) return ATTENDANCE_MENU_KEYS;
  if (TASKS_PLAN_IDS.includes(planId)) return TASKS_MENU_KEYS;
  if (FULL_PLAN_IDS.includes(planId)) return null;
  return null;
};

export const isMenuRestrictedForPlan = (planId, menuKey) => {
  const allowedKeys = getAllowedMenuKeys(planId);
  if (!allowedKeys) return false;
  return !allowedKeys.has(menuKey);
};

export const isMenuAllowedForPlan = (planId, menuKey) =>
  !isMenuRestrictedForPlan(planId, menuKey);

export const getMenuKeyForPath = (pathname) => {
  const match = ROUTE_MENU_MAP.find(
    ([path]) => pathname === path || pathname.startsWith(`${path}/`)
  );
  return match ? match[1] : null;
};

export const isPathRestrictedForPlan = (planId, pathname) => {
  const menuKey = getMenuKeyForPath(pathname);
  if (!menuKey) return false;
  return isMenuRestrictedForPlan(planId, menuKey);
};
